export const HpEventCtaVariants = {
    CONTROL: 'control',
    HP_DUAL: 'hp_dual',
    POWER_DUAL: 'power_dual',
};

export const HpEventCtaCustom5ByVariant = {
    [HpEventCtaVariants.CONTROL]: 'Control',
    [HpEventCtaVariants.HP_DUAL]: 'HPDual',
    [HpEventCtaVariants.POWER_DUAL]: 'PowerDual',
};
